import { render, staticRenderFns } from "./ContractsWorkers.vue?vue&type=template&id=2f728718&"
import script from "./ContractsWorkers.vue?vue&type=script&lang=js&"
export * from "./ContractsWorkers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports